/* tslint:disable */
/* eslint-disable */
/**
 * HAU.ITDE.SpareParts.Purchase.NonShop.Portal.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ProblemDetails } from '../model';
/**
 * WebsiteConfigurationApi - axios parameter creator
 * @export
 */
export const WebsiteConfigurationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Website Page
         * @param {string} [locale] 
         * @param {string} [pageId] 
         * @param {string} [baseUrl] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1WebsiteconfigurationConfigurationGet: async (locale?: string, pageId?: string, baseUrl?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/websiteconfiguration/configuration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }

            if (pageId !== undefined) {
                localVarQueryParameter['pageId'] = pageId;
            }

            if (baseUrl !== undefined) {
                localVarQueryParameter['baseUrl'] = baseUrl;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WebsiteConfigurationApi - functional programming interface
 * @export
 */
export const WebsiteConfigurationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WebsiteConfigurationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Website Page
         * @param {string} [locale] 
         * @param {string} [pageId] 
         * @param {string} [baseUrl] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1WebsiteconfigurationConfigurationGet(locale?: string, pageId?: string, baseUrl?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1WebsiteconfigurationConfigurationGet(locale, pageId, baseUrl, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebsiteConfigurationApi.v1WebsiteconfigurationConfigurationGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WebsiteConfigurationApi - factory interface
 * @export
 */
export const WebsiteConfigurationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WebsiteConfigurationApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Website Page
         * @param {string} [locale] 
         * @param {string} [pageId] 
         * @param {string} [baseUrl] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1WebsiteconfigurationConfigurationGet(locale?: string, pageId?: string, baseUrl?: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.v1WebsiteconfigurationConfigurationGet(locale, pageId, baseUrl, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WebsiteConfigurationApi - interface
 * @export
 * @interface WebsiteConfigurationApi
 */
export interface WebsiteConfigurationApiInterface {
    /**
     * 
     * @summary Get Website Page
     * @param {string} [locale] 
     * @param {string} [pageId] 
     * @param {string} [baseUrl] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebsiteConfigurationApiInterface
     */
    v1WebsiteconfigurationConfigurationGet(locale?: string, pageId?: string, baseUrl?: string, options?: RawAxiosRequestConfig): AxiosPromise<string>;

}

/**
 * WebsiteConfigurationApi - object-oriented interface
 * @export
 * @class WebsiteConfigurationApi
 * @extends {BaseAPI}
 */
export class WebsiteConfigurationApi extends BaseAPI implements WebsiteConfigurationApiInterface {
    /**
     * 
     * @summary Get Website Page
     * @param {string} [locale] 
     * @param {string} [pageId] 
     * @param {string} [baseUrl] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebsiteConfigurationApi
     */
    public v1WebsiteconfigurationConfigurationGet(locale?: string, pageId?: string, baseUrl?: string, options?: RawAxiosRequestConfig) {
        return WebsiteConfigurationApiFp(this.configuration).v1WebsiteconfigurationConfigurationGet(locale, pageId, baseUrl, options).then((request) => request(this.axios, this.basePath));
    }
}

